import Typography from "@mui/material/Typography";
import React, {useState} from "react";
import classnames from "classnames";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Popover from "@mui/material/Popover";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import {DealModal} from "../PricingListPage/DealModal";
import {useFetchHook} from "../../hooks/useFetchHook";
import fetcher from "../../fetcher";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {toast} from "react-toastify";
import {useListDealsStore} from "../../stores/listDealsStore";
import {useModalsStore} from "../../stores/modalsStore";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useShallow} from "zustand/react/shallow";

export const ListDealCard = ( { deal, isSelected } ) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const openModal = useModalsStore((state) => state.openModal)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isDeleting, setIsDeleting] = useState(false)

    const [deleteDealResponse, deleteDeal] = useFetchHook(fetcher.deleteDeal)

    const {
        updateDealFromBackend,
        removeDeletedDealFromList,
    } = useListDealsStore(
        useShallow((state) => ({
            removeDeletedDealFromList: state.removeDeletedDealFromList,
            updateDealFromBackend: state.updateDealFromBackend,
        }))
    )


    useDidMountEffect(function updateListAfterDelete() {
        if (deleteDealResponse?.data?.data?.id) {
            removeDeletedDealFromList(deleteDealResponse?.data?.data?.id)
            toast.success("Successfully deleted deal.")
        }
    }, [deleteDealResponse])

    const car_detail = deal.car_detail

    const isLoading = false // updateDealResponse?.loading && dealId() === deal.id

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = (id) => {
        return deleteDeal(id)
    }

    const isPurchase = deal.is_purchase
    const quote = deal.formatted_quote

    return (
        <div
            onClick={() => {
                if (isTabletOrMobile) {
                    window.open(`/quotes/${deal.id}`, "_self")
                } else {
                    openModal({
                        element: DealModal,
                        id: "DealModal",
                        props: {
                            id: deal.id,
                            onSave: (newDealState) => updateDealFromBackend(newDealState),
                        },
                    })
                }
            }}
            className={classnames('ListDealCard', {
                selected: isSelected,
                isPurchase: isPurchase
            })}
        >
            <MoreHorizIcon
                className={classnames(
                    'action-icon', {
                        loader: isDeleting
                    }
                )}
                onClick={handleClick}
            />
            <Popover
                // id={id}
                onClick={(e) => e.stopPropagation()}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top'
                }}
            >
                <Typography
                    sx={{ p: 2, fontWeight: 500 }}
                    className={'ListDealCard-menu-item'}
                    onClick={() => handleDelete(deal.id)}
                >
                    Delete
                    <DeleteSharpIcon
                        className={classnames(
                            'action-icon', {
                                loader: isDeleting
                            }
                        )}
                    />
                </Typography>
            </Popover>
            <div
                className={'left'}
            >
                <div
                    className={'car-detail'}
                >
                    <Typography
                        sx={{
                            fontSize: '24px',
                            fontWeight: 'bold'
                        }}
                    >
                        {car_detail.year} {car_detail.make} {car_detail.model}{car_detail.is_new ? "" : " [Used]"}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '18px',
                        }}
                    >
                        {car_detail.trim}
                    </Typography>
                </div>


                <div className={'ListDealCard-lender'}>
                    {quote.lender_name}
                </div>

                <label>Description</label>
                <div className={'ListDealCard-description'}>
                    {deal.description}
                </div>
            </div>
            <div
                className={classnames('right', {
                    // isPurchase: isPurchase
                })}
            >
                <div
                    className={'pay-detail'}
                >
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            borderBottom: '1px solid white'
                        }}
                    >
                        { isPurchase ? 'PURCHASE' : 'LEASE'}
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '18px',
                            fontWeight: 'bold'
                        }}
                    >
                        ${quote.amount_due_at_signing}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '12px',
                        }}
                    >
                        Due at Signing
                    </Typography>

                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '18px',
                            fontWeight: 'bold'
                        }}
                    >
                        ${quote.monthly_payment}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '12px',
                        }}
                    >
                        Per Month
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '18px',
                            fontWeight: 'bold'
                        }}
                    >
                        {deal.term}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '12px',
                        }}
                    >
                        Months
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '18px',
                            fontWeight: 'bold'
                        }}
                    >
                        {deal.mileage}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '12px',
                        }}
                    >
                        Miles
                    </Typography>
                    <Typography
                        className={classnames('pay-detail_value', {
                            loading: isLoading
                        })}
                        sx={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                        }}
                    >
                        ${deal.profit}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '12px',
                        }}
                    >
                        Profit
                    </Typography>
                </div>
            </div>
        </div>
    )
}